"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunk52DAEPPLjs = require('./chunk-52DAEPPL.js');var _react = require('@emotion/react');var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _react3 = require('react');var _jsxruntime = require('react/jsx-runtime');var $=_react.css`
  .highlighter {
    opacity: 1;
  }
`,v=(e,t)=>e?t.palette.BASE_FILL:t.palette.SECONDARY,A=_styled2.default.a`
  min-height: ${e=>e.theme.measurements.spacing(24)};
  height: 100%;
  line-height: ${e=>e.theme.measurements.spacing(10)};
  font-size: ${e=>e.theme.measurements.spacing(7)};
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${e=>e.theme.measurements.spacing(2)};
  flex-direction: row;
  min-width: fit-content;
  width: auto;
  color: ${e=>v(e.$isActive,e.theme)};
  cursor: ${e=>e.$disabled?"not-allowed":"pointer"};
  pointer-events: ${e=>e.$disabled?"none":"auto"};
  position: relative;

  &:hover {
    color: ${e=>e.theme.palette.BASE_FILL};
  }

  ${e=>e.$isActive?$:""}
`,T=_styled2.default.span`
  height: ${e=>e.theme.measurements.spacing(1)};
  background: ${e=>e.theme.palette.BASE_FILL};
  border-top-right-radius: ${e=>e.theme.measurements.shape(2)};
  border-top-left-radius: ${e=>e.theme.measurements.shape(2)};
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
`,S=_react3.forwardRef.call(void 0, (e,t)=>{let{children:l,index:i,isActive:c,title:d,tabLabel:s,disabled:h,className:m}=e,n=_chunk52DAEPPLjs.b.call(void 0, ).tabsInfo.selectedTabIndex===i||c,o=_chunk52DAEPPLjs.b.call(void 0, ).setActiveTab,b=_react3.useCallback.call(void 0, g=>{g.preventDefault(),o(i||0,e)},[i,o]);return _jsxruntime.jsxs.call(void 0, A,{$isActive:n||!1,$disabled:h,title:d||s,href:"#",onClick:b,className:`${m||""} aquilla-tab tab ${n?"activetab":""}`,ref:t,children:[s||l,_jsxruntime.jsx.call(void 0, T,{className:"highlighter"})]})}),I= exports.a =S;exports.a = I;
